import axiosInstance from './interceptor'

export const profileGet = async () => {

    return await axiosInstance.get('/user/GetInternalUser').then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const profileUpdate = async (params: any) => {

    return await axiosInstance.put('/user/UpdateUserDesignation', params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}